import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';

import {
  WORK_ORDER_STOCK_TRANSFER_CACHE_PAYLOAD_VERSION,
  WORK_ORDER_STOCK_TRANSFER_CACHE_SCOPE,
} from './constants';
import { parseFormCacheEnvelope } from './parseEnvelope';

/**
 * PUT /system/form-cache/{scope}
 * @param {{ expectedRevision: number, payload: object, payloadVersion?: number }} body
 * @param {string} [scope]
 */
export async function saveFormCache(
  { expectedRevision, payload, payloadVersion },
  scope = WORK_ORDER_STOCK_TRANSFER_CACHE_SCOPE,
) {
  const { data: raw } = await request.put(
    `/system/form-cache/${scope}`,
    keysToSnake({
      expectedRevision,
      payloadVersion:
        payloadVersion ?? WORK_ORDER_STOCK_TRANSFER_CACHE_PAYLOAD_VERSION,
      payload,
    }),
  );
  return parseFormCacheEnvelope(raw);
}
